import React from "react";
import {IProduct} from 'data/interfaces/products';
import SellerComments from 'gui/pages/mainRouter/pages/ad/components/commons/sellerComments';

import numeral from 'numeral';
import {currencyValueToLabel} from 'gui/components/formikCurrencySelector';
import {generateBaggageText} from 'gui/components/editors/flightEditor/components/ticketDetailsForm/components/baggageDetails/components/baggageSelector';

export interface IFlightSellerCommentsProps {
  product: IProduct;
}


const generateCancellationPrice = product => {
  return "לא ניתן לבטל";
  /*
  if (product && product.ticketDetails && product.ticketDetails.cancelPrice > 0)
    return [numeral(product.ticketDetails.cancelPrice).format("0,0"), currencyValueToLabel[product.ticketDetails.currency]].join(" ")
  return "ללא דמי ביטול";
   */
};

const generateChangePrice = product => {
  if (product && product.ticketDetails && product.ticketDetails.changePrice > 0)
    return [numeral(product.ticketDetails.changePrice).format("0,0"), currencyValueToLabel[product.ticketDetails.currency]].join(" ")
  return "ללא דמי שינוי"
};

const FlightSellerComments = (props: IFlightSellerCommentsProps) => <SellerComments
  title="מידע על הטיסה"
  description={props.product.ticketDetails.additionalServices || ''}
  details={[
    {
      title: 'כבודה',
      value: generateBaggageText(props.product)
    },
    {
      title: 'דמי ביטול',
      value: generateCancellationPrice(props.product)
    },
 //   {
 //     title: 'דמי שינוי',
 //     value: generateChangePrice(props.product)
 //   },
  ]}
/>;

FlightSellerComments.defaultProps = {
  product: {hotelDetails: {}},
};

export default FlightSellerComments;
